import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import AgyleDialog from "../../../components/modal/agyleDialog";
import InformationBox from "../../../components/other/informationBoxNew";
import { useDemographicsStyles } from "../admitStyles";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";

export default function RemoveNextOfKinEntryModal({
  admit,
  onRemoveNok,
  closeDialog,
  isDialogOpen,
  removedIndex,
}) {
  const { t } = useTranslation();
  const classes = useDemographicsStyles();

  return (
    <AgyleDialog
      onSave={onRemoveNok}
      closeButtonOnHeader
      disableEscapeKeyDown
      disableActionsCloseButton
      open={!!isDialogOpen}
      onClose={closeDialog}
      title={t("Remove Next of Kin entry")}
    >
      <InformationBox type="warning" xs={12}>
        <div className={clsx(classes.currentPatient)}>
          <Typography variant="body1" fontWeight={500}>
            {t("Remove Next of Kin entry.")}
          </Typography>

          <Typography variant="body1">
            {t(
              "Please confirm you want to remove following Next of Kin entry.",
            )}
          </Typography>
        </div>
      </InformationBox>

      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        gap={1}
        sx={{ pl: 1 }}
      >
        <Chip
          className={classes.infoPt}
          label={`First Name: ${
            admit.nokList[removedIndex]?.firstName || "no first name was given"
          }`}
        />

        <Chip
          className={classes.infoPt}
          label={`Last Name: ${
            admit.nokList[removedIndex]?.lastName || "no last name was given"
          }`}
        />

        <Chip
          className={classes.infoPt}
          label={`Address: ${
            admit.nokList[removedIndex]?.address || "no address was given"
          }`}
        />

        <Chip
          className={classes.infoPt}
          label={`Postal Code: ${
            admit.nokList[removedIndex]?.postalCode ||
            "no postal code was given"
          }`}
        />

        <Chip
          className={classes.infoPt}
          label={`Phone Number: ${
            admit.nokList[removedIndex]?.phoneNumber ||
            "no phone number was given"
          } `}
        />

        <Chip
          className={classes.infoPt}
          label={`Relationship: ${
            admit.nokList[removedIndex].relationship?.__description ||
            "no relationship was given"
          }`}
        />
      </Grid>
    </AgyleDialog>
  );
}